import React from 'react';

// Material Ui
import { IconButton, Snackbar } from '@mui/material';

// Icon
import CloseIcon from '@mui/icons-material/Close';
import { connect } from 'react-redux';

const BannerChatError = ( props ) => {

    // External props
    const { handleClose } = props;

    // States
    const { errorSaveChat } = props;    

    const snackbarStyles = {
        backgroundColor: '#FF7474',
        borderRadius: '8px',
        color: 'white',
        '.MuiPaper-root': {
            backgroundColor: '#FF7474',
            fontFamily: 'Poppins',
            borderRadius: '8px',
            fontWeight: '500'
        }
    }

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={ handleClose }
                sx={{ backgroundColor: '#EB5757' }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <Snackbar
            open={ errorSaveChat }
            autoHideDuration={ 3000 }
            anchorOrigin={{ 
                vertical: "bottom", 
                horizontal:"right" 
            }}
            onClose={ handleClose }
            message={ "Error" }
            action={ action }
            sx={ snackbarStyles }
        />
    )
}

const mapStateToProps = state => {
    return {
        errorSaveChat: state.stepsChat.errorSaveChat,
    }
}

export default connect(mapStateToProps, null)(BannerChatError);